import { render, staticRenderFns } from "./EmojiFlag.vue?vue&type=template&id=1c4b320a&"
import script from "./EmojiFlag.vue?vue&type=script&lang=ts&"
export * from "./EmojiFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports